export const DATA_DISCLAIMER =
  "*Any items with an asterisk indicate that we're having trouble getting the latest data so it may appear lower than the actual number";
